import OnSalePropertiesError from './BricksReservationError';
class TraderDoesNotHasReservedBricks extends OnSalePropertiesError {
    constructor() {
        super('Trader does not has reserved bricks');
    }
}
export default TraderDoesNotHasReservedBricks;
